"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactPage = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _react = _interopRequireWildcard(require("react"));
var _input = _interopRequireDefault(require("../../forms/input"));
var _textarea = _interopRequireDefault(require("../../forms/textarea"));
var _emailSender = require("../../../utils/clients/emailSender");
var _formValidator = require("../../../utils/clients/formValidator/formValidator");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _contactPageUtils = require("./contactPageUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ContactPage = props => {
  const {
    t,
    contactDetails,
    apiUrl,
    recaptchaKey
  } = props;
  const [name, setName] = (0, _react.useState)("");
  const [email, setEmail] = (0, _react.useState)("");
  const [subject, setSubject] = (0, _react.useState)("");
  const [userMessage, setUserMessage] = (0, _react.useState)("");
  const [formSubmitted, setFormSubmitted] = (0, _react.useState)(false);
  const [isSubmitSuccess, setIsSubmitSuccess] = (0, _react.useState)(false);
  const [submissionErrors, setSubmissionErrors] = (0, _react.useState)(false);
  const [isRobot, setIsRobot] = (0, _react.useState)(true);
  const website = contactDetails.website;
  const nameInputHandler = e => {
    setName(e.target.value);
  };
  const emailInputHandler = e => {
    setEmail(e.target.value);
  };
  const subjectInputHandler = e => {
    setSubject(e.target.value);
  };
  const messageInputHandler = e => {
    setUserMessage(e.target.value);
  };
  const captchaHandler = () => {
    setIsRobot(false);
  };
  const submitData = async e => {
    e.preventDefault();
    setFormSubmitted(true);
    if (isRobot || !email || !name || !userMessage || email.length > 50 || name.length > 50 || userMessage.length > 2000 || website.length < 1 || !website) {
      setSubmissionErrors(true);
      return false;
    }
    if ((0, _formValidator.isValidEmail)(email)) {
      (0, _emailSender.sendEmail)(name, email, subject, userMessage, apiUrl, website).then(() => setIsSubmitSuccess(true)).catch(() => {
        setSubmissionErrors(true);
      });
    }
    return true;
  };
  const renderAddress = address => {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
      className: "con-heading con-heading__h5"
    }, address.lineOne), /*#__PURE__*/_react.default.createElement("ul", {
      className: "con-text con-text__large-medium"
    }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, address.lineTwo)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, address.lineThree)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, address.city)), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, address.postCode))));
  };
  const renderContactDetails = contactDetails => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "con-contact-details"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "con-text con-text__green-contact con-centered"
    }, t("Pages.Contact.Contacts")), /*#__PURE__*/_react.default.createElement("div", {
      className: "con-contact-grid"
    }, (0, _contactPageUtils.renderListOfContacts)(contactDetails.contacts, t), renderAddress(contactDetails.address)));
  };
  (0, _react.useEffect)(() => {
    document.title = t("Pages.Contact.Title");
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h3"
  }, t("Pages.Contact.Header")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-subtitle con-subtitle__narrow con-text con-text__Xtra-larger-regular"
  }, t("Pages.Contact.Description"))), " ", !isSubmitSuccess ? /*#__PURE__*/_react.default.createElement("div", {
    className: "con-form-container trapezoid-section-background trapezoid-section-background__wider"
  }, submissionErrors && /*#__PURE__*/_react.default.createElement("div", {
    className: "con-form-errors"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-heading con-heading__h5"
  }, t("Pages.Contact.Form.Errors.SubmissionHeading")), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__Xtra-larger-regular"
  }, t("Pages.Contact.Form.Errors.SubmissionBody"))), /*#__PURE__*/_react.default.createElement("form", {
    className: "con-form-container__form"
  }, /*#__PURE__*/_react.default.createElement("fieldset", null, /*#__PURE__*/_react.default.createElement(_input.default, {
    error: formSubmitted && !name,
    label: t("Pages.Contact.Form.Name"),
    value: name,
    maxLength: "100",
    name: "name",
    onChange: nameInputHandler,
    errorMessage: t("Pages.Contact.Form.Errors.Name")
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    error: formSubmitted && !(0, _formValidator.isValidEmail)(email),
    label: t("Pages.Contact.Form.Email"),
    name: "email",
    maxLength: "320",
    value: email,
    onChange: emailInputHandler,
    errorMessage: t("Pages.Contact.Form.Errors.Email")
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "subject",
    label: t("Pages.Contact.Form.Subject"),
    maxLength: "100",
    value: subject,
    onChange: subjectInputHandler
  }), /*#__PURE__*/_react.default.createElement(_textarea.default, {
    error: formSubmitted && !userMessage,
    name: "message",
    label: t("Pages.Contact.Form.Message"),
    value: userMessage,
    onChange: messageInputHandler,
    errorMessage: t("Pages.Contact.Form.Errors.Message"),
    rows: "18"
  }), /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    sitekey: recaptchaKey,
    onChange: captchaHandler,
    className: "recaptcha"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "additional-button-border"
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "contact-form-button",
    className: "con-form__button con-text__medium-medium con-text__button con-text__button--green",
    disabled: false,
    type: "submit",
    onClick: submitData
  }, t("Common.Submit"))))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "con-form-container trapezoid-section-background trapezoid-section-background__wider trapezoid-section-background__smaller-padding"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-form-container__content"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text con-text__Xtra-larger-regular con-text__Xtra-larger-regular--semibold"
  }, t("Pages.Contact.Form.SuccessMessage")))), /*#__PURE__*/_react.default.createElement("div", null, renderContactDetails(contactDetails))));
};
exports.ContactPage = ContactPage;
ContactPage.propTypes = {
  contactDetails: _propTypes.default.shape({
    contacts: _propTypes.default.array,
    address: _propTypes.default.object,
    website: _propTypes.default.string
  }),
  t: _propTypes.default.func,
  apiUrl: _propTypes.default.string,
  recaptchaKey: _propTypes.default.string
};